'use strict';

angular.module('substoreApp.services')
    .factory('asyncI18nLoader', ["$http", "$q", "uiservice", "sessionData", function ($http, $q, uiservice, sessionData) {
        return function (options) {
            var deferred = $q.defer();
            sessionData.promise.then(function () {
                // load localization files

                uiservice.i18nMessages({
                        sessionId: sessionData.sessionId,
                        lang: sessionData.dialogStaticData.language,
                        wpId: sessionData.dialogStaticData.wholesalePartnerId
                    },
                    function success(response) {
                        if (response.data && response.data.translations)
                            deferred.resolve(response.data.translations);
                        else
                            deferred.reject(options.key);
                    },
                    function error(response) {
                        deferred.reject(options.key);
                    }
                );
            });
            return deferred.promise;
        };
    }]);